import injector from 'vue-inject'

injector.constant('defaultSettings', {
  fontSize: 16,
  margin: 5,
  newOrderRing: true,
  preOrderRing: true
})

const storeSetting = {
  store: {}
}
injector.constant('storeSetting', storeSetting)
